<script setup>
import { useI18n } from 'vue-i18n';
import Draggable from 'vuedraggable';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import TaskKanbanCard from './TaskKanbanCard.vue';

const props = defineProps({
  title: { type: String, required: true },
  status: { type: String, required: true },
  dot: { type: String, default: 'bg-n-slate-9' },
  modelValue: { type: Array, required: true },
});

const emit = defineEmits(['card-moved-in', 'edit-task', 'add-task']);

const { t } = useI18n();

const onChange = event => {
  if (event.added) {
    emit('card-moved-in', {
      taskId: event.added.element.id,
      status: props.status,
    });
  }
};
</script>

<template>
  <div class="flex flex-col gap-2.5 flex-1 min-w-[225px]">
    <div class="flex items-center gap-2 px-1">
      <span class="size-1.5 rounded-full flex-shrink-0" :class="dot" />
      <span class="text-sm font-semibold text-n-slate-12 truncate">
        {{ title }}
      </span>
      <span class="ltr:ml-auto rtl:mr-auto text-xs font-medium text-n-slate-10">
        {{ modelValue.length }}
      </span>
    </div>
    <!-- The stretched drop zone keeps empty columns easy to drag into even
         though visually they are just a header floating on the canvas. -->
    <Draggable
      :list="modelValue"
      class="flex flex-col gap-2.5 flex-1 min-h-[8rem] rounded-xl"
      group="tasks-kanban"
      item-key="id"
      animation="200"
      ghost-class="ghost"
      @change="onChange"
    >
      <template #item="{ element }">
        <TaskKanbanCard :task="element" @edit="emit('edit-task', element)" />
      </template>
      <template #footer>
        <button
          type="button"
          class="flex items-center gap-1.5 px-1 py-1.5 text-xs font-medium text-n-slate-10 hover:text-n-blue-text transition-colors w-fit"
          @click="emit('add-task')"
        >
          <Icon icon="i-lucide-plus" size="size-3" />
          {{ t('TASKS_DASHBOARD.KANBAN.ADD_TASK') }}
        </button>
      </template>
    </Draggable>
  </div>
</template>
